module.exports = __webpack_public_path__ + "img/accessory_pants_07.8275f916.svg";